import {
  CreateReducer,
  CreateAction,
} from '../utils/store'

import {
  handlers,
} from '../utils/api'

import ENV from '../../utils/globalEnv'

import {
  SystemState,
  ReducerHandler,
  ThunkHandler,
} from '../../types/store'

const prefix = 'system'

/*

  initial state

*/
const initialState: SystemState = {
  initialised: false,
}

/*

  reducers

*/
const setInitialised: ReducerHandler<SystemState, boolean> = (state, action) => {
  state.initialised = action.payload
}

/*

  thunks

*/
const initialise: ThunkHandler<void, void> = () => async (dispatch, getState) => {
  // const env = await handlers.get<any>('/env')
  // Object.keys(env).forEach(name => {
  //   ENV[name] = env[name]
  // })
  dispatch(actions.setInitialised(true))
}

/*

  collections

*/
const reducers = {
  setInitialised,
}

export const actions = {
  setInitialised: CreateAction(prefix, `setInitialised`, setInitialised),
  initialise,
}

export const reducer = CreateReducer<SystemState>({
  prefix,
  initialState,
  reducers,
})

export default actions
